const cityOptions = [
  {
    label: 'Bangalore',
    value: 'Bangalore'
  },
  {
    label: 'Delhi',
    value: 'Delhi'
  },
  {
    label: 'Mumbai',
    value: 'Mumbai'
  },
  {
    label: 'Pune',
    value: 'Pune'
  },
  {
    label: 'Others',
    value: 'Others'
  }
];

const updateStatusOptions = [
  {
    label: 'Open',
    value: 'OPEN'
  },
  {
    label: 'Follow Up',
    value: 'FOLLOW_UP'
  },
  {
    label: 'Rejected',
    value: 'LEAD_REJECTED'
  },
  {
    label: 'Interested',
    value: 'INTERESTED'
  }
];

const updateSubStatusForOpen = [
  {
    label: 'Fresh',
    value: 'FRESH'
  },
  {
    label: 'Call Back later',
    value: 'CALL_BACK_LATER'
  },
  {
    label: 'RNR',
    value: 'RNR'
  },
  {
    label: 'Phone busy',
    value: 'PHONE_BUSY'
  }
];

const updateSubStatusForFollowUp = [
  {
    label: 'Call Back later',
    value: 'CALL_BACK_LATER'
  },

  {
    label: 'RNR',
    value: 'RNR'
  },
  {
    label: 'Phone busy',
    value: 'PHONE_BUSY'
  }
];

const updateSubStatusForRejected = [
  {
    label: 'Poor banking',
    value: 'POOR_BANKING'
  },

  {
    label: 'Not interested',
    value: 'NOT_INTERESTED'
  },
  {
    label: 'High rate of interest',
    value: 'HIGH_ROI'
  },
  {
    label: 'Negative Profile',
    value: 'NEGATIVE_PROFILE'
  },

  {
    label: 'No documents',
    value: 'NO_DOCUMENTS'
  },
  {
    label: 'Unserviceable area',
    value: 'UNSERVICEABLE_AREA'
  },
  {
    label: 'No ownership',
    value: 'NO_OWNERSHIP'
  },
  {
    label: 'Invalid number',
    value: 'INVALID_NUMBER'
  },
  {
    label: 'Others',
    value: 'OTHERS'
  }
];

export function timeIntalval(passInerval) {
  let start = 0;
  let options = [];
  let totalMinutes = 24 * 60;
  while (start < totalMinutes) {
    let hour = Math.floor(start / 60);
    let minutes = Math.floor(start % 60);
    let label = `${hour < 10 ? '0' + hour : hour} : ${
      minutes < 10 ? '0' + minutes : minutes
    }`;
    let value = label;
    options.push({
      label,
      value
    });
    start += passInerval;
  }
  return options;
}
export {
  cityOptions,
  updateStatusOptions,
  updateSubStatusForOpen,
  updateSubStatusForFollowUp,
  updateSubStatusForRejected
};
